import { useRef } from "react";
import { useOutsideAlerter } from "../../lib/hooks";

export default function OutsideClickComponent({ children, task, ignorePortalRootClicks, className, extraInsideRefs }) {
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef, task, !!ignorePortalRootClicks, extraInsideRefs);

    return <div ref={wrapperRef} className={className}>{children}</div>;
}
